@if (locationSummaryDtos && locationForm && onlineBookingUrlsForm) {
  <form [formGroup]="locationForm" class="page-root">
    <mat-card>
      <mat-card-header class="row-space-between">
        <mat-card-title>{{ "form.label.location" | transloco }}</mat-card-title>

        <div class="card-action" (click)="addLocation()">
          <mat-icon> add_circle</mat-icon>
          <mat-label>{{"location.add_location" | transloco}}</mat-label>
        </div>
      </mat-card-header>

      <mat-card-content class="column-stretch">
        <mat-form-field>
          <mat-label>{{ "form.label.location" | transloco }}</mat-label>
          <mat-select (selectionChange)="changeLocation($event)" [formControl]="locationSelector">
            @for (locationSummaryDto of locationSummaryDtos; track $index) {
              <mat-option [value]="locationSummaryDto.locationId"> {{ locationSummaryDto.name }}
                - {{ locationSummaryDto.city }}, {{ locationSummaryDto.street }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <div class="row-wrap">
      <div class="page-item">
        <mat-card>
          <mat-card-header>
            <mat-card-title>{{"label.address" | transloco}}</mat-card-title>
          </mat-card-header>
          <mat-card-content class="column-stretch">
            <mat-form-field hideRequiredMarker="true">
              <mat-label>{{ "location.name" | transloco }}</mat-label>
              <input matInput type="text" formControlName="name" />
            </mat-form-field>

            <mat-form-field hideRequiredMarker="true">
              <mat-label>{{ "form.label.street" | transloco }}</mat-label>
              <input matInput type="text" formControlName="street" />
            </mat-form-field>

            <div class="row-wrap">
              <mat-form-field hideRequiredMarker="true" class="horizontal-constraint">
                <mat-label>{{ "form.label.zipCode" | transloco }}</mat-label>
                <input matInput type="text" formControlName="zipCode" />
              </mat-form-field>

              <mat-form-field hideRequiredMarker="true" class="flex">
                <mat-label>{{ "form.label.countryCode" | transloco }}</mat-label>
                <input matInput type="text" formControlName="country" />
                <mat-error>{{"error.validation.countryCode" | transloco}}</mat-error>
              </mat-form-field>


            </div>

            <mat-form-field hideRequiredMarker="true" class="flex">
              <mat-label>{{ "form.label.city" | transloco }}</mat-label>
              <input matInput type="text" formControlName="city" />
            </mat-form-field>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="page-item">
        <mat-card>
          <mat-card-header>
            <mat-card-title>{{"label.contact" | transloco}}</mat-card-title>
          </mat-card-header>
          <mat-card-content class="column-stretch">
            <mat-form-field hideRequiredMarker="true">
              <mat-label>{{"form.label.phone" | transloco}}</mat-label>
              <input matInput type="text" formControlName="phone" />
              <mat-error>{{"error.validation.phone" | transloco}}</mat-error>
            </mat-form-field>
            <mat-form-field hideRequiredMarker="true">
              <mat-label>{{"form.label.mobile" | transloco}}</mat-label>
              <input matInput type="text" formControlName="mobile" />
              <mat-error>{{"error.validation.phone" | transloco}}</mat-error>
            </mat-form-field>
            <mat-form-field hideRequiredMarker="true">
              <mat-label>{{"form.label.email" | transloco}}</mat-label>
              <input matInput type="text" formControlName="emailAddress" />
              <mat-error>{{"error.validation.email" | transloco}}</mat-error>
            </mat-form-field>
            <mat-form-field hideRequiredMarker="true">
              <mat-label>{{ "form.label.home_page" | transloco }}</mat-label>
              <input matInput type="text" formControlName="homePageUrl" />
              <mat-error>{{"error.validation.url" | transloco}}</mat-error>
            </mat-form-field>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <div class="row-wrap">
      <div class="page-item">
        <mat-card>
          <mat-card-header>
            <mat-card-title>{{ "location.app_settings" | transloco }}</mat-card-title>
          </mat-card-header>

          <mat-card-content class="column-stretch">
            <mat-form-field hideRequiredMarker="true">
              <mat-label>{{"location.label.min_advance_cancellation_hours" | transloco}}</mat-label>
              <input matInput type="text" formControlName="minAppAdvanceCancellationHours" />
            </mat-form-field>

            <mat-checkbox formControlName="appCanCancelAppointment">{{"location.label.app_patient_can_cancel" | transloco}}
            </mat-checkbox>
          </mat-card-content>
        </mat-card>
        <mat-card>
          <mat-card-header>
            <mat-card-title>{{"location.booking_settings" | transloco}}</mat-card-title>
          </mat-card-header>

          <mat-card-content class="column-stretch">
            <mat-form-field>
              <mat-label>{{ "location.label.preferred_language" | transloco }}</mat-label>
              <mat-select formControlName="preferredLanguage">
                @for (code of ["en", "de", "fr", "it"]; track $index) {
                  <mat-option [value]="code">{{ code | language }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field hideRequiredMarker="true">
              <mat-label>{{"location.label.external_id" | transloco}}</mat-label>
              <input matInput type="text" formControlName="externalId" />
            </mat-form-field>

            <mat-form-field hideRequiredMarker="true">
              <mat-label>{{ "location.label.max_advance_booking_days" | transloco }}</mat-label>
              <input matInput type="text" formControlName="maxAdvanceBookingDays" />
            </mat-form-field>

            <mat-form-field hideRequiredMarker="true">
              <mat-label>{{ "location.label.min_future_booking_hours" | transloco }}</mat-label>
              <input matInput type="text" formControlName="minFutureBookingHours" />
            </mat-form-field>

            <mat-form-field hideRequiredMarker="true">
              <mat-label>{{"location.label.min_advance_cancellation_hours" | transloco}}</mat-label>
              <input matInput type="text" formControlName="minAdvanceCancellationHours" />
            </mat-form-field>

            <mat-form-field hideRequiredMarker="true">
              <mat-label>{{"location.label.min_group_appointment_cancellation_hours" | transloco}}</mat-label>
              <input matInput type="text" formControlName="minGroupAppointmentAdvanceCancellationHours" />
            </mat-form-field>

            <mat-form-field hideRequiredMarker="true">
              <mat-label>{{"location.label.max_appointments_per_week" | transloco}}</mat-label>
              <input matInput type="text" formControlName="maxAppointmentsPerWeek" />
            </mat-form-field>

            <mat-form-field hideRequiredMarker="true">
              <mat-label>{{ "location.label.max_appointments_total" | transloco}}</mat-label>
              <input matInput type="text" formControlName="maxAppointmentsTotal" />
            </mat-form-field>

            <mat-form-field hideRequiredMarker="true">
              <mat-label>{{"location.label.max_group_appointments_per_week" | transloco}}</mat-label>
              <input matInput type="text" formControlName="maxGroupAppointmentsPerWeek" />
            </mat-form-field>

            <mat-form-field hideRequiredMarker="true">
              <mat-label>{{ "location.label.max_appointment_frequency" | transloco}}</mat-label>
              <mat-select formControlName="maxAppointmentFrequency">
                @for (id of [0, 1, 2, 3, 4, 5, 6, 7, 8]; track $index) {
                  <mat-option [value]="id">{{ id | appointmentDistance }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field hideRequiredMarker="true">
              <mat-label>{{ "form.label.start_time_interval_minutes" | transloco }}</mat-label>
              <input matInput type="text" formControlName="startTimeIntervalMinutes" />
            </mat-form-field>

            <mat-form-field>
              <mat-label>{{"location.label.email_notifications" | transloco}}</mat-label>
              <mat-select formControlName="emailNotificationSettings" multiple>
                @for (
                  setting of [EmailNotificationSettingEnum.cancellation, EmailNotificationSettingEnum.initial, EmailNotificationSettingEnum.note, EmailNotificationSettingEnum.booking]; track $index) {
                  <mat-option [value]="setting">{{ setting | emailNotificationSettings }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-checkbox formControlName="groupAppointmentWithSubscriptionOnly">
              {{"location.label.group_appointment_with_subscription_only" | transloco}}
            </mat-checkbox>

            <mat-checkbox formControlName="startIntervalRelativeToSlot">
              {{"location.label.start_interval_relative_to_slot" | transloco}}
            </mat-checkbox>

            <mat-checkbox formControlName="useCompanyAsSender">
              {{"location.label.use_company_as_sender" | transloco}}
            </mat-checkbox>

            <mat-checkbox formControlName="hideBookingWarning">
              {{"location.label.hide_booking_warning" | transloco}}
            </mat-checkbox>

            <mat-checkbox formControlName="hideAnyTherapist">
              {{"location.label.hide_any_therapist" | transloco}}
            </mat-checkbox>

            <mat-checkbox formControlName="warnOnTherapistChange">
              {{"location.label.warn_on_therapist_change" | transloco}}
            </mat-checkbox>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="page-item">
        <mat-card>
          <mat-card-header>
            <mat-card-title>{{ "label.logo" | transloco }}</mat-card-title>
          </mat-card-header>

          <mat-card-content class="column-gap">
            @if (imagePreview) {
              <div class="logo-container">
                <img [src]="imagePreview" class="logo" />
              </div>
            } @else {
              <div class="logo-container"></div>
            }
            <input type="file" accept="image/*" class="hidden" (change)="uploadImage($event)" #fileUpload />
            <div class="row-gap-small">
              <button mat-icon-button (click)="deleteImage()">
                <mat-icon>delete</mat-icon>
              </button>
              <button mat-flat-button (click)="fileUpload.click()">{{"label.add_image" | transloco}}</button>
            </div>
            @if (imageError) {
              <mat-error>{{imageError}}</mat-error>
            }
          </mat-card-content>
        </mat-card>

        <mat-card>
          <mat-card-header>
            <mat-card-title>{{"form.label.booking_hint" | transloco}}</mat-card-title>
          </mat-card-header>

          <mat-card-content class="column-stretch">
            <mat-tab-group class="column-stretch" formArrayName="bookingHint">
              @for (group of bookingHint.controls; let i = $index; track $index) {
                <mat-tab [label]="group.get('language')?.value | language">
                  <mat-form-field hideRequiredMarker="true" [formGroupName]="i" class="tab-body">
                    <mat-label>{{"form.label.booking_hint_description" | transloco}}</mat-label>
                    <textarea matInput rows="3" formControlName="value"></textarea>
                  </mat-form-field>
                </mat-tab>
              }
            </mat-tab-group>
          </mat-card-content>
        </mat-card>

        <mat-card>
          <mat-card-header>
            <mat-card-title>{{ "location.color_settings" | transloco }}</mat-card-title>
          </mat-card-header>
          <mat-card-content class="column-stretch">
            <div class="row-wrap">
              <div class="column-gap-small">
                <mat-label>{{ "location.label.primary_color" | transloco }}</mat-label>
                <input type="color" formControlName="primaryColor" />
              </div>

              <div class="column-gap-small">
                <mat-label>{{ "location.label.secondary_color" | transloco }}</mat-label>
                <input type="color" formControlName="secondaryColor" />
              </div>

              <div class="column-gap-small">
                <mat-label>{{ "location.label.tertiary_color" | transloco }}</mat-label>
                <input type="color" formControlName="tertiaryColor" />
              </div>
            </div>

            <mat-checkbox formControlName="applyColorsToEmails">{{"location.label.apply_colors_to_emails" | transloco}}</mat-checkbox>
          </mat-card-content>
        </mat-card>

        <mat-card>
          <mat-card-header>
            <mat-card-title>{{ "location.communication" | transloco }}</mat-card-title>
          </mat-card-header>

          <mat-card-content class="column-stretch">
            <mat-tab-group class="column-stretch" formArrayName="confirmationText">
              @for (group of confirmationText.controls; let i = $index; track $index) {
                <mat-tab [label]="group.get('language')?.value | language">
                  <mat-form-field hideRequiredMarker="true" [formGroupName]="i" class="tab-body">
                    <mat-label>
                      {{"location.label.patient_notification_email" | transloco}}
                    </mat-label>
                    <textarea matInput rows="3" formControlName="value"></textarea>
                  </mat-form-field>
                </mat-tab>
              }
            </mat-tab-group>

            @if (useMailing) {
              <mat-form-field>
                <mat-label>{{ "form.label.sender_mail" | transloco }}</mat-label>
                <mat-select [(value)]="selectedSender" (selectionChange)="changeSender($event)" [compareWith]="compareSenders">
                  @for (dto of emailSenders; track $index) {
                    @if (dto?.email && dto!.email!.length > 0) {
                      <mat-option [value]="dto"> {{ dto.email }}</mat-option>
                    }
                    @else{
                      <mat-option [value]="dto"> {{ dto.senderName }}</mat-option>
                    }
                  }
                </mat-select>
              </mat-form-field>

              @if (selectedSender?.email) {
                <mat-form-field>
                  <mat-label>{{ "form.label.sender_name" | transloco }}</mat-label>
                  <input matInput type="text" formControlName="senderName" />
                </mat-form-field>
              }
            }
          </mat-card-content>
        </mat-card>

        <mat-card>
          <mat-card-header class="row-space-between">
            <mat-card-title>{{"location.label.app_booking_links" | transloco}}</mat-card-title>
            <div class="card-action" (click)="addOnlineBookingUrl()">
              <mat-icon class="card-action-icon">add_circle</mat-icon>
              <mat-label>{{"location.label.add_link" | transloco}}</mat-label>
            </div>
          </mat-card-header>

          <mat-card-content>
            <mat-table [dataSource]="onlineBookingUrlsForm.controls" #onlineBookingUrlsTable>
              <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef>{{ "form.label.label" | transloco }}</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.value.name | localizedText }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="link">
                <mat-header-cell *matHeaderCellDef>{{ "form.label.url" | transloco }}</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.value.link }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let element" class="row-end">
                  <button mat-icon-button color="primary" (click)="editOnlineBookingUrl(element)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button color="warn" (click)="deleteOnlineBookingUrl(element)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="['name', 'link', 'actions']"></mat-header-row>
              <mat-row *matRowDef="let row; columns: ['name', 'link', 'actions'];"></mat-row>
            </mat-table>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </form>
}
